module.exports = __webpack_public_path__ + "static/media/favs4.3c8d94bb.jpg";